// extracted by mini-css-extract-plugin
export default {"tablehead":"TableProductData_tablehead__BJFRH","custom-striped-table":"TableProductData_custom-striped-table__Brphc"};